import { createSlice } from "@reduxjs/toolkit";
import { getBarList } from "./thunk";

export interface IState {
  bars: any;
  isBarLoading: boolean;
  isBarSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  bars: null,
  isBarLoading: false,
  isBarSuccess: false,

  error: {},
};

const AdvertisementSlice = createSlice({
  name: "BarList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Advertisements
    builder.addCase(getBarList.pending, (state: IState, action: any) => {
      state.isBarLoading = true;
    });
    builder.addCase(
      getBarList.fulfilled,
      (state: IState, action: any) => {
        state.bars = action.payload.data;
        state.isBarSuccess = true;
        state.isBarLoading = false;
      }
    );
    builder.addCase(
      getBarList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isBarSuccess = false;
        state.isBarLoading = false;
      }
    );
  },
});

export default AdvertisementSlice.reducer;
